import React from "react";
import "./App.css";
import Scroller from "./Scroller";

function App() {
  return <Scroller />;
}

export default App;
